var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointOnlyTooltip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 .6A6.398 6.398 0 0 0 .6 7c0 3.536 2.864 6.4 6.4 6.4 3.536 0 6.4-2.864 6.4-6.4C13.4 3.464 10.536.6 7 .6Zm0 10.104a.604.604 0 0 1-.6-.6c0-.328.272-.6.6-.6.328 0 .6.272.6.6 0 .328-.272.6-.6.6Zm.944-3.64c-.336.176-.544.576-.544 1.008v.432c0 .224-.176.4-.4.4a.396.396 0 0 1-.4-.4v-.432c0-.736.368-1.392.968-1.712A1.198 1.198 0 0 0 7 4.104c-.664 0-1.2.536-1.2 1.2 0 .224-.176.4-.4.4a.396.396 0 0 1-.4-.4 2 2 0 0 1 4 0c0 .736-.4 1.408-1.056 1.76Z",
  fill: "#8B97A7"
})));
export default SvgPointOnlyTooltip;